import { IAccount } from '@modeso/types__aumico-lib-annualreport-be';

export interface IProfitCalculationTableData {
    name: string | IAccount | null;
    currentValue: number | null;
    previousValue: number | null;
    customAccountName?: string | null;
}
